import script from "./MenuItem.vue?vue&type=script&setup=true&lang=js"
export * from "./MenuItem.vue?vue&type=script&setup=true&lang=js"

import "./MenuItem.vue?vue&type=style&index=0&id=9b4e4080&scoped=true&lang=scss"
import "./MenuItem.vue?vue&type=style&index=1&id=9b4e4080&lang=css"

import exportComponent from "/home/ubuntu/workspace/Official-tianwen-frontend/node_modules/_vue-loader@17.0.1@vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9b4e4080"]])

export default __exports__